import IMApis from "../net/IMApis";
import IMApp from "../net/IMApp";
import MessageType from "../net/IMMessageType";
import IMUsers from "../net/IMUsers";


export default class FIMUtils {

    static isLogin = false;

    static init() {

    }

    static getFriendList() {
        return IMApp.getFriendList();
    }

    static getGroupList() {
        return IMApp.getGroupList();
    }

    static getApplyFriendList() {
        return IMApp.getApplyFriendList();
    }

    static applyFriend(uid, handletype) {
        return IMApp.applyFriend(uid, handletype);
    }

    static getConversationList() {
        return IMApp.getConversationList();
    }

    static getConversationMessageList(conversationId) {
        return IMApp.getConversationMessageList(conversationId)
    }

    //修改红包的内存
    static setRedBagItem(conversationId, redBagId, type) {
        IMApp.setConversationMessageItem(conversationId, redBagId, type)
    }

    static sendMessage(recvuid, msg_type, content, isGroup = false, clientkey = '', authcode = '', nopush = 0) {
        return IMApp.sendMessage(recvuid, msg_type, content, isGroup, clientkey, authcode, nopush);
    }

    static sendTextMessage(recvuid, content, isGroup = false) {
        return IMApp.sendMessage(recvuid, MessageType.TXT, content, isGroup);
    }

    static openRedBag(id) {
        return IMApp.openRedBag(id);
    }

    static RedBagInfo(id) {
        return IMApp.RedBagInfo(id);
    }

    static sendImageMessage(recvuid, file, isGroup = false) {
        return IMApp.sendImageMessage(recvuid, file, isGroup);
    }

    static sendChatRoomMessage(chatRoomId, content) {
        return IMApp.sendChatRoomMessage(chatRoomId, MessageType.TXT, content);
    }

    static getUserProfile(uids) {
        return IMUsers.getUsersList(uids);
    }

    static logout(func) {
        FIMUtils.isLogin = false;
        IMApp.logout();
        func && func();
    }

    static quitGroup(groupkey) {
        return IMApp.quitGroup(groupkey);
    }

    static joinGroup(groupkey) {
        return IMApp.joinGroup(groupkey);
    }

    //验证码登录
    static codeLogin(zone, phone, verifycode) {

        return IMApis.login(zone, phone, verifycode);

    }

    //快捷登录登录
    static fastLogin(phone, fastkey) {

        return IMApis.fastLogin2(phone, fastkey);

    }

    //游客登录
    static ykLogin(phone, fastkey) {

        return IMApis.ykLogin(phone, fastkey);

    }
    //密码登录
    static passwordLogin(phone, password) {

        return IMApis.passWordlogin(phone, password);

    }

    //忘记密码
    static FindPassword(phone, code, password) {

        return IMApis.FindPassword(phone, code, password);

    }
    //设置密码
    static SetPassword(password) {
        return IMApis.SetPassword(password);
    }
    //修改登录密码
    static ChangePassword(oldPassword, password) {
        return IMApis.changePassword(oldPassword, password);
    }

    //检查是否有登录密码
    static checkPassword() {
        return IMApis.checkPassword();
    }

    //im获取验证码
    static getCode(zone, phone) {

        return IMApis.getCode(zone, phone);

    }

    static connectWebSocket(result) {
        //去连接
        IMApis.thirdLogin(result).then(result => {
            FIMUtils.isLogin = true;
        }).catch(e => {
            FIMUtils.isLogin = false;
        })

    }

    static login(phone, uid) {
        if (FIMUtils.isLogin) {
            return;
        }

        IMApis.thirdLogin(phone, uid).then(result => {
            FIMUtils.isLogin = true;
        }).catch(e => {
            FIMUtils.isLogin = false;
        })


        // if (!phone || phone.length != 11 || !sign || sign.length == 0) {
        // IMApis.testImLogin('86', '19100000006', '681539').then(result => {
        //     FIMUtils.isLogin = true;
        // }).catch(e => {
        //     FIMUtils.isLogin = false;
        // })
        // } else {
        //     IMApis.imLogin(phone, sign).then(result => {
        //         FIMUtils.isLogin = true;
        //     }).catch(e => {
        //         FIMUtils.isLogin = false;
        //     })
        // }
    }

    static isMessageText(type) {
        return type == MessageType.TXT;
    }

    static isRedBag(type) {
        return type == MessageType.REDBAG;
    }

    static isMessageImage(type) {
        return type == MessageType.IMAGE
    }
    static isComing(type) {
        return type == MessageType.COMING
    }

    static setMessageRead(conversationId) {
        IMApp.setMessageRead(conversationId);
    }

    static isMe(uid) {
        return IMApp.isMe(uid);
    }

    static getFixImageSize(size, maxWidth = document.body.clientWidth / 2) {
        if (size.width == size.height) {
            if (size.width > maxWidth) {
                size.width = maxWidth;
                size.height = maxWidth;
            }
        } else if (size.width > size.height) {
            if (size.width > maxWidth) {
                size.width = maxWidth;
                size.height = maxWidth * (size.height / size.width);
            }
        } else {
            if (size.height > maxWidth) {
                size.width = maxWidth * (size.width / size.height);
                size.height = maxWidth;
            }
        }
        return size;
    }

    static createChatKey(uid) {
        return IMApp.createChatKey(IMApp.user.uid, uid);
    }
}